import isString from "ramda-extension/es/isString";
import { TRACEPARENT_HEADER, instrumentTypes } from '../../constants';
import { createEventDescription } from '../../utils/description';
import { triggerHandlers } from '../../utils/handlers';
import { fill } from '../../utils/object';
const createXHRInteractionEvent = createEventDescription(instrumentTypes.XHR);
export function instrumentXHR() {
    if (!('XMLHttpRequest' in global)) {
        return;
    }
    const xhrproto = XMLHttpRequest.prototype;
    fill(xhrproto, 'open', (originalOpen)=>function(...args) {
            const url = args[1];
            this.__apm_xhr__ = {
                method: isString(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if apm key appears in URL, don't capture it as a request
            if (isString(url) && this.__apm_xhr__.method === 'POST' && url.match(/intake/)) {
                this.__apm_own_request__ = true;
            }
            const onreadystatechangeHandler = ()=>{
                if (this.readyState === 4) {
                    if (!this.__apm_own_request__) {
                        try {
                            // touching statusCode in some platforms throws
                            // an exception
                            this.__apm_xhr__.status_code = this.status;
                        } catch (_e) {
                        /* do nothing */ }
                        if (this.getAllResponseHeaders().indexOf(TRACEPARENT_HEADER) >= 0) {
                            this.__apm_xhr__.traceid = this.getResponseHeader(TRACEPARENT_HEADER);
                        }
                        const { method, url, status_code, body, traceid } = this.__apm_xhr__ || {};
                        triggerHandlers(instrumentTypes.XHR, createXHRInteractionEvent({
                            method,
                            url,
                            status_code,
                            body,
                            traceid
                        }));
                    }
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
                fill(this, 'onreadystatechange', (original)=>(...readyStateArgs)=>{
                        onreadystatechangeHandler();
                        return original.apply(this, readyStateArgs);
                    });
            } else {
                this.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(this, args);
        });
    fill(xhrproto, 'send', (originalSend)=>function(...args) {
            if (this.__apm_xhr__ && args[0] !== undefined) {
                this.__apm_xhr__.body = args[0];
            }
            // tohle v sentry nesbiraj ve vysledku
            // triggerHandlers(
            // 	instrumentTypes.XHR,
            // 	createXHRInteractionEvent({
            // 		args,
            // 		xhr: this,
            // 	})
            // );
            return originalSend.apply(this, args);
        });
}
